import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import LandingPage from "./pages/LandingPage";
import ServicePage from "./pages/ServicePage";
import ServiceDetail from "./pages/ServiceDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Resources from "./pages/Resources";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
// import ApplicationMain from "./pages/ApplicationMain";
import { Toaster } from "./components/ui/sonner";

// Layout wrapper to conditionally show navbar/footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isLandingPage = location.pathname === '/lp';

  return (
    <>
      {!isLandingPage && <Navbar />}
      {children}
      {!isLandingPage && <Footer />}
      <Toaster />
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/lp" element={<LandingPage />} />
              <Route path="/about" element={<About />} />
              <Route path="/services/:serviceType" element={<ServicePage />} />
              <Route path="/services/:category/:serviceSlug" element={<ServiceDetail />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              {/* <Route path="/application/main" element={<ApplicationMain />} /> */}
            </Routes>
          </Layout>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
